import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { TimeFrame, UpdateEatingWayTimeFramePayload } from './models/TimeFrame';
import { UpdateTimeFrameMenuBookPositionPayload } from './models/UploadTimeFrameMenuBookPositionPayload';

const timeframeService = {
  getAll(timeframeId: number): Promise<CommonResponse<TimeFrame>> {
    let url = `/timeframe/${timeframeId}`;
    return axiosClient.get(url);
  },
  add(timeframeId: number, param: { menu_book_id: number; course_id: number | null }[]): Promise<CommonResponse<null>> {
    const url = `/timeframe/${timeframeId}`;
    return axiosClient.post(url, param);
  },
  update(timeframeId: number, payload: UpdateEatingWayTimeFramePayload): Promise<CommonResponse<null>> {
    const url = `/timeframe/${timeframeId}`;
    return axiosClient.patch(url, payload);
  },
  delete(
    timeframeId: number,
    params: { menu_book_id: number; course_id: number | null }[]
  ): Promise<CommonResponse<null>> {
    const url = `/timeframe/${timeframeId}`;
    return axiosClient.delete(url, { data: params });
  },
  updatePosition(timeframeId: number, params: UpdateTimeFrameMenuBookPositionPayload[]): Promise<CommonResponse<null>> {
    const url = `/timeframe/${timeframeId}`;
    return axiosClient.patch(url, params);
  },
};

export default timeframeService;
